import HomePage from "../pages/HomePage/HomePage";

export const routes = [{ path: "/home", component: HomePage }];
